import cardAudienceStyle from "../styles/cardAudience.module.scss";

function CardAudiencePicker({
  action,
  step = "format",
  options,
  heading,
  onChooseFormat,
  onChooseAudience,
  onBack,
  onCancel,
}) {
  if (!action) {
    return null;
  }

  const isCopy = action === "clipboard";
  const verb = isCopy ? "Copy" : "Download";
  const formatHeading = isCopy
    ? "Copy image or card to clipboard"
    : "Download image or card directly to your computer";

  if (step === "audience") {
    return (
      <div
        className={cardAudienceStyle.picker}
        role="dialog"
        aria-label={`${verb} info card for`}
      >
        <p className={cardAudienceStyle.heading}>
          {heading || `${verb} info card for`}
        </p>
        <div className={cardAudienceStyle.options}>
          {options.map((option) => (
            <button
              key={option.id || "none"}
              type="button"
              className={`${cardAudienceStyle.option} ${
                option.id === "" ? cardAudienceStyle.defaultOption : ""
              }`}
              onClick={() => onChooseAudience(option.id)}
            >
              {option.label}
            </button>
          ))}
          <button
            type="button"
            className={cardAudienceStyle.cancel}
            onClick={onBack}
          >
            Back
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      className={`${cardAudienceStyle.picker} ${cardAudienceStyle.formatPicker}`}
      role="dialog"
      aria-label={formatHeading}
    >
      <p className={`${cardAudienceStyle.heading} ${cardAudienceStyle.formatHeading}`}>
        {formatHeading}
      </p>
      <div className={cardAudienceStyle.formatRow}>
        <button
          type="button"
          className={`${cardAudienceStyle.option} ${cardAudienceStyle.defaultOption}`}
          onClick={() => onChooseFormat("named")}
        >
          Single Image
        </button>
        <button
          type="button"
          className={cardAudienceStyle.option}
          onClick={() => onChooseFormat("card")}
        >
          Info card
        </button>
      </div>
      <button
        type="button"
        className={cardAudienceStyle.cancel}
        onClick={onCancel}
      >
        Cancel
      </button>
    </div>
  );
}

export default CardAudiencePicker;
